export const SET_IS_SELECT_NEW = 'SET_IS_SELECT_NEW';

export interface IsSelectNewAction {
  readonly type: string;
  readonly selectNew: boolean;
}

export const setSelectNew = (selectNew: boolean): IsSelectNewAction => ({
  type: SET_IS_SELECT_NEW,
  selectNew,
});
